import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';

function Footerbar({ toggleSidebar }) {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const containerStyle = {
    width: '100%',
    backgroundColor: '#e6f4ea', // light green
    borderTop: '1px solid #d0e0d0',
    padding: '12px 0 8px',
    position: 'fixed',
    bottom: 0,
    left: 0,
    zIndex: 999, // ensure it's above everything else
  };

  const navStyle = {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    maxWidth: '600px',
    margin: '0 auto',
  };

  const navItemStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: '12px',
    color: '#333',
    textDecoration: 'none',
    flex: 1,
  };

  const activeStyle = {
    color: '#2e7d32', // darker green for text
    fontWeight: 600,
  };

  const iconStyle = {
    color: '#1b5e20', // deep green (from the image)
    fontSize: '18px',
    marginBottom: '4px',
  };

  return (
    <div style={containerStyle}>
      <div style={navStyle}>
        <Link
          to="/family-settings"
          style={{
            ...navItemStyle,
            ...(isActive("/family-settings") ? activeStyle : {}),
          }}
        >
          <i className="bi bi-file-earmark-text" style={iconStyle}></i>
          <span>Family</span>
        </Link>

        <Link
          to="/family-tree"
          style={{
            ...navItemStyle,
            ...(isActive("/family-tree") ? activeStyle : {}),
          }}
        >
          <i className="bi bi-tree" style={iconStyle}></i>
          <span>Tree</span>
        </Link>

        <Link
          to="/home"
          style={navItemStyle}
        >
          <i
            className="bi bi-house-door-fill"
            style={{ ...iconStyle, fontSize: '20px' }}
          ></i>
          <span style={isActive("/home") ? activeStyle : {}}>Home</span>
        </Link>

        <Link
          to="/gallery"
          style={{
            ...navItemStyle,
            ...(isActive("/gallery") ? activeStyle : {}),
          }}
        >
          <i className="bi bi-image" style={iconStyle}></i>
          <span>Gallery</span>
        </Link>

        <a
          onClick={toggleSidebar}
          style={{ ...navItemStyle, cursor: 'pointer' }}
        >
          <i className="bi bi-list" style={iconStyle}></i>
          <span>Menu</span>
        </a>
      </div>
    </div>
  );
}

export default Footerbar;
